import React from "react";
import { StatusBar, useColorScheme, View } from "react-native";
import { AuthContextProvider } from "@infrastructure/auth/AuthContextProvider";
import { Provider as PaperProvider } from "react-native-paper";
import { EventEmitter } from "@events/Event.emitter";
import Toast from "react-native-toast-message";
import "@config/i18n";
import { QueryClient, QueryClientProvider } from "react-query";
import { theme } from "@config/Theme";
import { LanguagesContextProvider } from "@infrastructure/context/languages/LanguageContextProvider";

export const AppProviders = ({ children }: any) => {
  const isDarkMode = useColorScheme() === "dark";
  const queryClient = new QueryClient();

  return (
    <PaperProvider theme={theme}>
      <EventEmitter>
        <View style={{ flex: 1 }}>
          <StatusBar barStyle={isDarkMode ? "light-content" : "dark-content"} />
          <QueryClientProvider client={queryClient}>
            <>
              <LanguagesContextProvider>
                <AuthContextProvider>{children}</AuthContextProvider>
              </LanguagesContextProvider>
              <Toast />
            </>
          </QueryClientProvider>
        </View>
      </EventEmitter>
    </PaperProvider>
  );
};
